import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {SearchPage} from './components/search-page/search-page';
import { CollPanelComponent } from './components/coll-panel/coll-panel.component';
import {SearchRepository} from './repositories/search.repository';
import {SearchService} from './services/search.service';
import { LeadaComponentsModule } from 'shared/components';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild([
      { path: '', component: SearchPage },
    ]),
    TranslateModule,
    LeadaComponentsModule,
  ],
  providers: [
    SearchRepository,
    SearchService,
  ],
  declarations: [
    SearchPage,
    CollPanelComponent,
  ],
})
export class SearchModule { }
